// extracted by mini-css-extract-plugin
export default {"container":"Positioned-module__container"};